<template>
  <div class="common-viewer-container">
    <iframe
      v-if="
        includeSuffix(url, [
          'doc',
          'docx',
          'xls',
          'xlsx',
          'ppt',
          'pptx',
          'pdf',
          'zip',
          'rar',
          '7z',
        ])
      "
      class="w-full h-full"
      style="height: 100%"
      :src="getUrl(url)"
    />
    <div
      v-else-if="includeSuffix(url, ['png', 'jpg', 'gif', 'jpeg', 'webp'])"
      class="w-full h-full"
      style="height: 100%"
    >
      <InlineViewer :images="[url]" :options="{ backdrop: true }" class="w-full h-full" />
    </div>
    <div v-else>
      在线预览只支持.doc、.docx、.xls、.xlsx、.ppt、.pptx、.zip、.rar、.7z格式的文件
    </div>
  </div>
</template>
<script setup lang="ts">
import InlineViewer from "./InlineViewer.vue";

defineProps<{
  url: string;
}>();

const includeSuffix = (url: string, list: string[] = []) => {
  if (!url) {
    return;
  }
  const extension = url.split(".").pop()?.toLowerCase() || "";
  return list.includes(extension);
};

function getUrl(url: string) {
  let fileUrl = url;
  var i = "21627";
  var ssl = "&ssl=1";
  var a = fileUrl.substr(0, 5);
  if (a !== "https") {
    ssl = "";
  }

  // 测试 /image.driverglobe.com 域名
  if (fileUrl.indexOf("image.fat.driverglobe.com") != -1) {
    i = "35347";
  }

  return "https://vip.ow365.cn/?i=" + i + ssl + "&furl=" + fileUrl;
}
</script>
